<div class="pageheader">
    <div class="page-title">
        <h1>Concurrency Keys</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Concurrency key log'">
                <app-change-log-link-entity type="ConcurrencyKey" [id]="''"></app-change-log-link-entity>
            </app-change-log-link>
            <button class="btn btn-link" (click)="showActiveTickets()">Show active tickets <ep-svg-icon icon="paper"></ep-svg-icon></button>
        </div>
    </div>
</div>

<div class="xcontainer xcontainer-fixed">
    <div class="xrow">
        <div class="col-sm-12">
            <dx-data-grid biz-grid
                          [selection]='{ mode: "none" }'
                          [dataSource]='concurrencyKeys'
                          [bizHideSelectedRowsComponent]="true"
                          [showResetButton]="true"
                          (onInitNewRow)="onInitNewRow($event)"
                          (onRowInserting)="onRowInserting($event)"
                          (onRowUpdating)="onRowUpdating($event)"
                          (onRowRemoving)="onRowRemoving($event)"
                          [bizEditRowOnDoubleClick]="true">

                <dxo-editing mode="popup"
                                [allowAdding]="hasCreatePerm"
                                [allowUpdating]="hasEditPerm"
                                [allowDeleting]="hasDeletePerm">
                    <dxo-popup title="Concurrency Key Edit" [showTitle]="true"></dxo-popup>

                </dxo-editing>


                <dxi-column dataField="Name" width="200" caption="Name" dataType="string" [allowGrouping]="false" sortOrder="asc"><dxi-validation-rule type="required"></dxi-validation-rule></dxi-column>
                <dxi-column dataField="MaxConcurrentActivities" width="180"  caption="Concurrent activities" dataType="number" [allowGrouping]="false" >
                    <dxi-validation-rule type="required"></dxi-validation-rule>
                    <dxi-validation-rule type="range" [min]="1" [max]="1000"
                        message="Concurrent activities must be set to a value from 1 through 1000."></dxi-validation-rule>
                </dxi-column>

                <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="true">
                    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(concurrencyKeys, 'CreatedBy'))"></dxo-header-filter>
                </dxi-column>
                <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="true" format="dateTime"></dxi-column>
                <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="true">
                    <dxo-header-filter [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(concurrencyKeys, 'UpdatedBy'))"></dxo-header-filter>
                </dxi-column>
                <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="true" format="dateTime"></dxi-column>

                <dxi-column type="buttons" alignment="right">
                    <dxi-button name="edit"></dxi-button>
                    <dxi-button name="delete"></dxi-button>
                    <dxi-button text="Show Log"
                                template="logTemplate"
                                [visible]="hasShowLogPerm">
                    </dxi-button>
                </dxi-column>

                <ng-container *dxTemplate="let cell of 'logTemplate'">
                    <app-change-log-link *bizPermissionRequired="'Developer_Action_ShowLog'" [title]="'Log'" [showIcon]="false" classNames="dx-link">
                        <app-change-log-link-entity type="ConcurrencyKey" [id]="cell.data.Id"></app-change-log-link-entity>
                    </app-change-log-link>
                </ng-container>

            </dx-data-grid>
        </div>
    </div>
</div>

<ng-template #activeTicketsTemplate let-c="close" let-d="dismiss">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="d()">
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Active tickets</h4>
    </div>
    <div class="form-group modal-body">
        <i>Concurrency keys are short-lived (depending on the step it performs). This list only shows active tickets - all postponed tickets are not shown here.</i>
        <dx-data-grid biz-grid
                      [selection]='{ mode: "none" }'
                      [dataSource]='activeTickets'
                      [bizHideSelectedRowsComponent]="true"
                      [showResetButton]="true"
                      [showRefreshButton]="true"
                      (onRefresh)="getActiveTickets()"
                      (onRowRemoving)="onTicketRowRemoving($event.data)"
                      [bizEditRowOnDoubleClick]="true">

            <dxo-editing mode="popup"
                         [allowAdding]="false"
                         [allowUpdating]="false"
                         [allowDeleting]="hasDeletePerm">
            </dxo-editing>


            <dxi-column dataField="KeyName" caption="ConcurrencyKey Name" dataType="string" sortOrder="asc"></dxi-column>
            <dxi-column dataField="Ticket.CreatedDate" caption="Created" dataType="datetime" sortOrder="asc" [format]="dateTimeService.getDevExpressDateTimeWithMsFunction"></dxi-column>
            <dxi-column dataField="Ticket.Note" caption="Created" dataType="datetime"></dxi-column>
            <dxi-column dataField="Ticket.Value" caption="Ticket Value" dataType="string"></dxi-column>
        </dx-data-grid>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="c()">Close</button>
    </div>
</ng-template>
